/* eslint react-hooks/exhaustive-deps: 0 */
import React, {
  useImperativeHandle,
  forwardRef,
  useState,
  useEffect,
  useLayoutEffect,
} from 'react';
import { useValidation } from '../../hooks';
import * as S from './styled';

import {
  required,
  lessThan,
  greaterThan,
  isAnyInvalidField,
} from '../../utils/inputValidation';

const OPERATION = {
  PLUS: '+',
  LESS: '-',
};

export const SELECTOR_TYPE = {
  CURRENCY: 100,
  DEFAULT: 1,
};

const ValueSelector = (
  {
    minValue = 0,
    maxValue = 0,
    calculationValue,
    className,
    number,
    onChange,
    selectorType = SELECTOR_TYPE.DEFAULT,
    errorLess = 'Valor indisponivel',
    errorMore = 'Valor indisponivel',
    msgFooter,
    ...rest
  },
  ref
) => {
  const [selectorRef, validateSelector] = useValidation();
  const [message, setMessage] = useState(msgFooter);
  const [pressed, setPressed] = useState('');
  const [longAction, setLongAction] = useState();
  const validValue = value =>
    value >= minValue * selectorType && value <= maxValue * selectorType;

  const updateValue = (operation, value) => {
    let newValue = value;
    switch (operation) {
      case OPERATION.PLUS:
        newValue += calculationValue * selectorType;
        break;
      case OPERATION.LESS:
        newValue -= calculationValue * selectorType;
        break;
      default:
        break;
    }

    return newValue;
  };

  const handleButtonClick = operation => {
    if (minValue === 0 && maxValue === 0) {
      return;
    }
    if (validValue(number.value)) {
      const newValue = updateValue(operation, number.value);

      if (validValue(newValue)) {
        setMessage(msgFooter);
        onChange({ ...number, value: newValue });
      } else if (newValue > maxValue * selectorType) {
        setMessage('Valor máximo');
      } else {
        setMessage('Valor mínimo');
      }
    } else if (number.value > maxValue * selectorType) {
      onChange({
        ...number,
        value: maxValue * selectorType,
        invalid: validateSelector().invalid,
      });
    } else {
      onChange({
        ...number,
        value: minValue * selectorType,
        invalid: validateSelector().invalid,
      });
    }
  };
  useLayoutEffect(() => setMessage(msgFooter), [msgFooter]);
  useImperativeHandle(
    ref,
    isAnyInvalidField([validateSelector], number.value),
    [validateSelector, number, isAnyInvalidField]
  );
  useEffect(() => {
    if (pressed) {
      setLongAction(setTimeout(() => handleButtonClick(pressed), 100));
    }
  }, [number.value]);

  const clearActions = () => {
    setPressed('');
    clearTimeout(longAction);
  };

  const performOperation = operation => e => {
    if (e.button === 0) {
      handleButtonClick(operation);
      setPressed(operation);
    }
  };
  return (
    <S.ValueSelectorWrapper className={className}>
      <S.RoundButton
        onMouseUp={clearActions}
        onMouseDown={performOperation(OPERATION.LESS)}
        onMouseLeave={clearActions}
      >
        <span>-</span>
      </S.RoundButton>
      <S.StyledInput
        {...rest}
        msgFooter={message}
        value={number.value}
        ref={selectorRef}
        onChange={value => onChange(value)}
        validations={[
          required,
          lessThan(maxValue * selectorType, errorLess),
          greaterThan(minValue * selectorType, errorMore),
        ]}
        invalid={number.invalid}
        errorMessage={number.errorMessage}
      />
      <S.RoundButton
        onMouseUp={clearActions}
        onMouseDown={performOperation(OPERATION.PLUS)}
        onMouseLeave={clearActions}
      >
        <span>+</span>
      </S.RoundButton>
    </S.ValueSelectorWrapper>
  );
};

export default forwardRef(ValueSelector);
